import { getPriceListApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    CreatePriceListRequest,
    GetPriceListsResponse,
    PriceListApiGetPriceListsRequest,
    PriceListResponse,
    UpdatePriceListRequest,
} from '@/core/generated/api';

/** Выполняет операции с прайс-листами */
export const priceListService = {
    /** Загружает страницу прайс-листов */
    async getList(request: PriceListApiGetPriceListsRequest): Promise<GetPriceListsResponse> {
        try {
            const response = await getPriceListApi().getPriceLists(request);

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает прайс-лист по идентификатору */
    async getById(id: string): Promise<PriceListResponse> {
        try {
            const response = await getPriceListApi().getPriceListById({ id });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Создаёт прайс-лист */
    async create(data: CreatePriceListRequest): Promise<PriceListResponse> {
        try {
            const response = await getPriceListApi().createPriceList({ createPriceListRequest: data });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Обновляет прайс-лист */
    async update(data: UpdatePriceListRequest): Promise<PriceListResponse> {
        try {
            const response = await getPriceListApi().updatePriceList({ updatePriceListRequest: data });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Деактивирует прайс-лист */
    async deactivate(id: string, comment?: string): Promise<void> {
        try {
            await getPriceListApi()
                .apiV1PriceListsIdDelete({
                    id,
                    deleteRequest: { comment }
                });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
